




























































































import { Component, Prop } from 'vue-property-decorator'

import FileApi from "../../../../../../../File/logic/file-api";
import { CashRegisterModel } from '../../../../../../../Shop/CashRegisters/types'
import { EditProductModel } from '../../../../../../../Shop/Products/types'
import ButtonView from '../../../../../components/NodeButtonsView/ButtonView.vue'
import { SocketNames } from '../../../../../components/Socket/SocketsHelper'
import SampleNodeMixin from '../../../SampleNodeMixin'
import { SendInvoiceNode } from '../logic/SendInvoiceNode'

@Component({
  data() {
    return {
      SocketNames,
    }
  },
  components: {
    ButtonView,
  }
})
export default class SampleSendInvoiceNode extends SampleNodeMixin {
  @Prop() node!: SendInvoiceNode

  fileApi = new FileApi()

  get cashRegister(): CashRegisterModel | undefined {
    if (this.node.data.cash_register_id) {
      return this.node.nodeProps.getCashRegisters()
        .find((c) => c.id === this.node.data.cash_register_id)
    }
    return undefined
  }

  get product(): EditProductModel | undefined {
    if (this.node.data.product_id) {
      return this.node.nodeProps.getProducts()
        .find((product) => product.id === this.node.data.product_id)
    }

    return undefined
  }
}
